import React from 'react';
import { EmeraldButton } from '@emerald-react/button';
import { useStyles } from './styles';
import EllisIcon from '../../../ai-in-sdlc/icons/EllisIcon';

interface InputDesignProps {
  subtitle?: string;
  title?: string;
  buttonLabel?: string;
  onExplore?: () => void;
}

const InputDesign: React.FC<InputDesignProps> = ({
  subtitle = "Hey John! we're excited to share",
  title = 'AI in Software Development Lifecycle',
  buttonLabel = 'Explore',
  onExplore,
}) => {
  const styles = useStyles();
  return (
    <>
      <section className={styles.inputDesignSection}>
        <div>
          <div className={styles.inputDesignIconDiv}>
            <EllisIcon />
          </div>
          <div>
            <p className={styles.inputDesignSubTitle}>{subtitle}</p>
            <h2 className={styles.inputDesignTitle}>{title}</h2>
          </div>
        </div>
        <EmeraldButton
          label={buttonLabel}
          onClick={onExplore}
          className={styles.button}
        />
      </section>
    </>
  );
};

export default InputDesign;
